import {
  ApplicationIdPathParam,
  IfpApplicationActionResponse,
  IfpApplicationIdPathParam,
  IfpApplicationReturnOrCancelActionPathParams,
  IfpApplicationSendActionRequest,
  IfpCreateApplicationRequest,
  IfpCreateApplicationResponse,
  IfpGetApplicationResponse,
  IfpUpdateApplicationRequest,
} from '@shared/sec-loans'
import { Endpoint, SignApplicationResponse } from '@shared/types'

export const ENDPOINT_IFP_GET_APPLICATION: Endpoint<IfpGetApplicationResponse, void, never, ApplicationIdPathParam> = {
  path: '/ifp/application/{applicationId}',
  method: 'get',
}

export const ENDPOINT_IFP_CREATE_APPLICATION: Endpoint<IfpCreateApplicationResponse, IfpCreateApplicationRequest> = {
  path: '/ifp/application',
  method: 'post',
}

export const ENDPOINT_IFP_UPDATE_APPLICATION: Endpoint<
  void,
  IfpUpdateApplicationRequest,
  never,
  ApplicationIdPathParam
> = {
  path: '/ifp/application/{applicationId}',
  method: 'put',
}

export const ENDPOINT_IFP_APPLICATION_SEND_ACTION: Endpoint<
  IfpApplicationActionResponse,
  IfpApplicationSendActionRequest,
  never,
  never
> = {
  path: '/ifp/application/{applicationId}/action/send',
  method: 'put',
}

export const ENDPOINT_IFP_APPLICATION_RETURN_OR_CANCEL_ACTION: Endpoint<
  IfpApplicationActionResponse,
  void,
  never,
  IfpApplicationReturnOrCancelActionPathParams
> = {
  path: '/ifp/application/{applicationId}/action/{action}',
  method: 'put',
}

export const ENDPOINT_SIGN_IFP_APPLICATION: Endpoint<SignApplicationResponse, never, never, IfpApplicationIdPathParam> =
  {
    path: '/ifp/application/{applicationId}/signing-url',
    method: 'get',
  }
